import RplPagination from './Pagination.vue'
import RplPrevNext from './PrevNext.vue'

export { RplPagination }
export { RplPrevNext }

export default RplPagination
